import { AlertIcon } from '@/components/ui/icons'

import styles from './formLayout.module.css'

interface FormErrorProps {
  message?: string
}

export function FormError({ message }: FormErrorProps) {
  if (!message) return null

  return (
    <p className={styles.alert} role="alert">
      <AlertIcon className={styles.alertIcon} />
      {message}
    </p>
  )
}
